import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function getNotificationsListRequest(pageParam) {
  return await api.get('/notification/', config('json', { page: pageParam }));
}

export async function getTodosListRequest(pageParam, done) {
  return await api.get('/todo/', config('json', { page: pageParam, done }));
}

export async function editTodosListStateRequest(id) {
  return await api.patch(generatePath('/todo/:id', id), {}, config('json'));
}

export async function markAllAsSeenRequestRequest() {
  return await api.patch('/notification/', {}, config('json'));
}
